module.exports = [{
      plugin: require('/Users/Tessa/dev/auslan-flashcards/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/Tessa/dev/auslan-flashcards/node_modules/gatsby-plugin-gtag/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-107311642-2","head":false,"anonymize":true},
    },{
      plugin: require('/Users/Tessa/dev/auslan-flashcards/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
